/**
* 图表界面
*/
<template>
  <!-- 组件主盒子 -->
  <div class="main">
    <!-- 面包屑导航 -->
    <!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
    <!--      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
    <!--    </el-breadcrumb>-->
    <div style="text-align: center; margin-top: 200px;">
      <p style="font-size: 32px; font-weight: bold; color: #6f7180;">{{ nowDateTime }}</p>
      <p style="font-size: 48px;">欢迎您使用表白墙信息后台管理平台</p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Chart from 'echarts'

export default {
  name: "welcome",
  data() {
    return {
      nowDateTime: null
    }
  },
  // 导入组件
  components: {
    // 点聚合组件
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.currentTime();
  },
  // 挂载结束状态(里面是操作)
  mounted() {
  },
  // 里面的函数只有调用才会执行
  methods: {
    //获取当前时间，并且格式化输出
    getTime() {
      let _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
      this.nowDateTime = yy + '年 ' + mm + '月' + dd + '日 ' + hh + ':' + mf + ':' + ss;
    },
    //定时任务，更新时间
    currentTime() {
      setInterval(this.getTime, 500)
    }
  }
};
</script>
<style>

.main {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/views/welcome.vue